import { object, string, array, union, literal } from 'zod';

// src/bloc/global-settings/schema.ts
var companySchema = object({
  siteName: string(),
  siteUrl: string(),
  companyName: string(),
  companyUrl: string(),
  representative: string(),
  headquarters: string(),
  tel: string(),
  contactUrl: string()
});
var formSchema = object({
  notePlaceholder: string()
});
var globalSettingsSchema = object({
  shared: object({
    company: companySchema,
    form: formSchema.optional()
  }),
  client: object({
    loginMethod: array(union([literal("google"), literal("twitter")]))
  }),
  admin: object({
    loginMethod: array(union([literal("google"), literal("twitter")]))
  })
});

export { globalSettingsSchema };
//# sourceMappingURL=chunk-OFEPDH3Z.mjs.map
//# sourceMappingURL=chunk-OFEPDH3Z.mjs.map